// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xTLM3","comment":"styles_comment__YiEtv"};